'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/8/28.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AttentionArtworkPageFilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AttentionArtworkPageFilterBar, _Component);

  function AttentionArtworkPageFilterBar() {
    (0, _classCallCheck3.default)(this, AttentionArtworkPageFilterBar);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AttentionArtworkPageFilterBar).apply(this, arguments));
  }

  (0, _createClass3.default)(AttentionArtworkPageFilterBar, [{
    key: 'itemClick',
    value: function itemClick(filterStr) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        onItemClick(filterStr);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var input = this.refs.searchInput.value;
      var onSearch = this.props.onSearch;

      if (onSearch) {
        onSearch(input);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./AttentionArtSalonPageFilterBar.scss');
      var texts = this.props.texts;

      var searchBtn = require('./ysslbg1.png');
      return _react2.default.createElement(
        'div',
        { style: { margin: '20px 0 0 30px' } },
        texts.map(function (currentFilter, index) {
          var curClassName = styles.sel_co1;
          switch (index) {
            case 1:
              curClassName = styles.sel_co2;
              break;
            case 2:
              curClassName = styles.sel_co3;
              break;
            case 3:
              curClassName = styles.sel_co4;
              break;
            default:
              curClassName = styles.sel_co1;
          }
          return _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                return _this2.itemClick(index);
              }, key: index,
              className: styles.sel_sl + ' ' + curClassName },
            currentFilter
          );
        }),
        _react2.default.createElement(
          'div',
          { className: styles.sel_sl + ' ' + styles.sel_co8 + ' ' + styles.sel_wh },
          _react2.default.createElement('input', { ref: 'searchInput', type: 'text', className: styles.sel_ip }),
          _react2.default.createElement(
            'div',
            { onClick: this.search.bind(this) },
            _react2.default.createElement('img', { className: styles.soo, src: searchBtn, alt: 'aa' })
          )
        )
      );
    }
  }]);
  return AttentionArtworkPageFilterBar;
}(_react.Component), _class.propTypes = {
  texts: _react.PropTypes.array.isRequired,
  onSearch: _react.PropTypes.func,
  onItemClick: _react.PropTypes.func
}, _temp);
exports.default = AttentionArtworkPageFilterBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AttentionArtSalonPageFilterBar/AttentionArtSalonPageFilterBar.js
 ** module id = 1310
 ** module chunks = 0
 **/